condition = true
obj = 
	text: "coffee test"

module.exports = obj.text if condition?


/** WEBPACK FOOTER **
 ** ./loaders/_resources/script.coffee
 **/